export enum OnboardingProductType {
  Returns = "returns",
  OrderEditing = "order-editing",
  Oms = "oms",
  ShippingFulfillment = "shipping-fulfillment",
  Chargebacks = "chargebacks",
  Withdrawals = "withdrawals",
  Contextual = "contextual",
  Recover = "recover",
  EmailSms = "email-sms",
  Aeo = "aeo",
  CheckoutOptimization = "checkout-optimization",
  AiSalesSupport = "ai-sales-support",
  InventoryManagement = "inventory-management",
  AgenticCatalog = "agentic-catalog",
  Conversion = "conversion",
  SupportAi = "support-ai",
}
